<template>
    <div>

        <b-row  class="mt-5 pl-5 pr-5" >
            <h5 style="text-align:center;width:100%;font-weight:bold;">近3年企业经营情况汇总表</h5>
            <b-table :items="summary" :fields="fields">

             
            </b-table>
        </b-row>
        <b-row class="mt-2">
            <Echart :options="chart_option['option_sales']" id="chart1" :style="{ height: height }"></Echart>
            <Echart :options="chart_option['option_deduct']" id="chart2" :style="{ height: height }"></Echart>
            <Echart :options="chart_option['option_product1']" id="chart3" :style="{ height: height }"></Echart>
            <Echart :options="chart_option['option_product2']" id="chart4" :style="{ height: height }"></Echart>
            <Echart :options="chart_option['option_shuifei']" id="chart5" :style="{ height: height }"></Echart>

            <Echart :options="chart_option['option_stack']" id="chart6" :style="{ height: height }"></Echart>


        </b-row>
        <!-- <b-row class="mt-1">
            <Echart :options="chart_option['option_decduct']" id="chart2" :style="{ height: height }"></Echart>
       </b-row>

       <b-row class="mt-1">
            <Echart :options="chart_option['option_product1']" id="chart2" :style="{ height: height }"></Echart>
       </b-row> -->

        <loading :show="pageLoading"></loading>
    </div>
</template>

<script>
import * as statFacade from "@/api/tcs-stat-facade.js";
import { get_option_sale } from "./option_sale.js";
import { get_option_deduct } from "./option_deduct.js";

import { get_option_product1,get_option_product2 ,get_option_shuifei} from "./option_product.js";

import { get_option_stack} from "./option_stack.js";

import Echart from "@/components/echart";

import {

  addYears
} from "date-fns/esm";


export default {
    data() {
        return {
            height: "500px",
            pageLoading: false,
            chart_option: {option_sales:{},option_deduct:{},option_product1:{},option_product2:{},option_shuifei:{}},
            entCode:"111",
         
            fields: [
                { key: 'seqNo', label: '序号' },
                { key: 'category', label: '类别' },
            ],
            summary:[]
        };
    },
    components: {
        Echart,
        
    },
   
    methods: {
        
        async getOptionData(){
            this.pageLoading = true;
           var res=await statFacade
                .getSalesStat(this.entCode);
                this.drawChart(res,'sales');

                var res2=await statFacade
                .getDeductStat(this.entCode);
                this.drawChart(res2,'deduct');

                var res3=await statFacade
                .getProductStat(this.entCode,"3040409%");
                this.drawChart(res3,'product1');

                var res4=await statFacade
                .getProductStat(this.entCode,"301010202%");
                this.drawChart(res4,'product2');

                var res5=await statFacade
                .getStackStat(this.entCode);
                this.drawChart(res5,'stack');

                  var res6=await statFacade
                .getProductStat(this.entCode,"110030101%");
                this.drawChart(res6,'shuifei');

             


                this.pageLoading = false;
        },
         //获取汇总数据
         getSummaryData(){
            this.pageLoading = true;
             statFacade
                .getSummaryStat(this.entCode).then(res=>{
                    this.summary=res;
                });
              

              //  this.pageLoading = false;
        },
         drawChart(res,label) {
            if(res==null){
                res=[];
            }
         res.reverse();
         switch(label){
           case 'sales':
             this.chart_option["option_"+label]=get_option_sale(res);
             break;
           case 'deduct':
             this.chart_option["option_"+label]=get_option_deduct(res); 
             break;
           case 'product1':
             this.chart_option["option_"+label]=get_option_product1(res);
             break;
            case 'product2':
             this.chart_option["option_"+label]=get_option_product2(res);
             break;
            case 'stack':
             this.chart_option["option_"+label]=get_option_stack(res);
             break;
             case 'shuifei':
             this.chart_option["option_"+label]=get_option_shuifei(res);
             break;
   
           default:
              this.chart_option["option_"+label]=get_option_sale(res);
         }

        this.loading=false;

        //   if(stationCode=='1149A'){
        //     this.chart_option["option_1149A"]=options;
        //   }

        //   if(stationCode=='1148A'){
        //     this.chart_option["option_1148A"]=options;
        //   }

          
        },
       

    },
    created(){
        this.entCode=this.$route.query.e;
        let date=new Date();
        let year3=date.getFullYear();
        let year2=year3-1;
        let year1=year2-1;
        this.fields.push({
            key:'year1Data',
            label:''+year1
        });
        this.fields.push({
            key:'year2Data',
            label:''+year2
        });
        this.fields.push({
            key:'year3Data',
            label:''+year3
        });
    },
  
    mounted() {
        this.height = document.documentElement.clientHeight * 0.78 + "px";
       
        this.getSummaryData();


        this.getOptionData();
     


    }
};
</script>
<style scoped>
#chart1,#chart2 {
    width: 100%;
}
</style>